const TRACK_VISIT_ENDPOINT =
  "https://script.google.com/macros/s/AKfycbzeJLQzU0FXQ4Twfb8yeyrT4qm5fUoygDUoRRU8ydPj-p3ijmulokgBJhnsTirtcWcJcA/exec";

function getOrCreateStorageId(key) {
  try {
    const existing = localStorage.getItem(key);

    if (existing) return existing;

    const value =
      crypto?.randomUUID?.() ||
      `${Date.now()}-${Math.random().toString(36).slice(2)}`;

    localStorage.setItem(key, value);

    return value;
  } catch {
    return null;
  }
}

function getOrCreateSessionId() {
  try {
    const key = "md_session_id";
    const existing = sessionStorage.getItem(key);

    if (existing) return existing;

    const value =
      crypto?.randomUUID?.() ||
      `${Date.now()}-${Math.random().toString(36).slice(2)}`;

    sessionStorage.setItem(key, value);

    return value;
  } catch {
    return null;
  }
}

export async function trackVisit() {
  try {
    const params = new URLSearchParams(window.location.search);

    const payload = {
      type: "visit",
      source: params.get("src") || params.get("utm_source") || "qr_general",
      campaign: params.get("campaign") || params.get("utm_campaign") || "qr_app_general",
      page_url: window.location.href,
      referrer: document.referrer || null,
      language: navigator.language || null,
      screen_width: window.screen?.width || null,
      screen_height: window.screen?.height || null,
      visitor_id: getOrCreateStorageId("md_visitor_id"),
      session_id: getOrCreateSessionId(),
      user_agent: navigator.userAgent || null,
    };

    const body = JSON.stringify(payload);

    console.log("MDL trackVisit payload", payload);
    console.log("MDL trackVisit endpoint", TRACK_VISIT_ENDPOINT);

    fetch(TRACK_VISIT_ENDPOINT, {
      method: "POST",
      body,
      keepalive: true,
      mode: "no-cors",
    }).catch((error) => {
      console.error("MDL TRACK ERROR", error);
    });
  } catch (error) {
    console.warn("[trackVisit] ignored", error);
  }
}